import React from "react";
import MaterialTable, { MTableBody } from "material-table";

export const DownloadableTable = (props) => {
	const fixedCols = props.fixedCols;
	return (
		<MaterialTable
			style={{ zIndex: 0 }} // to be displayed behind Select Value Container
			columns={props.cols}
			data={props.tableData}
			title={props.title}
			isLoading={props.isLoading}
			components={{
				Body: (body) => {
					return (
						<>
							<MTableBody {...body} />
							{props.tableFoot}
						</>
					);
				},
			}}
			options={{
				exportAllData: true,
				exportButton: true,
				exportFileName: `${props.fileName}`,
				onPageChange: true,
				headerStyle: {
					fontSize: "1.2rem",
				},
				searchFieldStyle: {
					fontSize: "1rem",
				},
				pageSize: 7,
				emptyRowsWhenPaging: false,
				pageSizeOptions: [
					20,
					30,
					50,
					100
				],
				fixedColumns: fixedCols, // left or right column(s) would be fixed
			}}
		/>
	);
};
